// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpSecondaryTabAceptarTodoGuardar extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.secondary_tab.aceptar_todo_guardar";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpSecondaryTabAceptarTodoGuardar {
        this.VALUES ??= this.completar({
            "valor": {
                "ca-ES": "D'acord amb tot i desar",
                "cz": "Přijměte vše a uložte",
                "da": "Accepter alt og gem",
                "de": "Alles akzeptieren und speichern",
                "en": "Accept all and save",
                "eu-ES": "Onartu guztiak eta gorde",
                "fi": "Hyväksy kaikki ja tallenna",
                "fr": "Tout accepter et enregistrer",
                "ga-ES": "Aceptar todo e gardar",
                "hi": "सब स्वीकार करो और बचाओ",
                "hu": "Fogadjon el mindent és mentse el",
                "it": "Accettare tutto e salvare",
                "no": "Godta alt og lagre",
                "nl": "Alles accepteren en opslaan",
                "pl": "Akceptuj wszystko i zapisz",
                "pt": "Aceitar tudo e guardar",
                "pt-BR": "Aceite tudo e salve",
                "ro": "Acceptă toate și salvează",
                "ru": "Принять всё и сохранить",
                "sk": "Prijať všetky a uložiť",
                "sv": "Acceptera alla och spara"
            },
            "defecto": "Aceptar todo y guardar"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
